// START - compose email custom block type
export const compose_email_custom_block_type_discount = "discount";
export const compose_email_custom_block_type_button = "button";
export const compose_email_custom_block_type_early_bird = "earlyBird";
// END - compose email custom block type

export const TYPES = {
  EXISTING: "existing",
  NEW: "new",
};

export const options = [
  {
    label: "Already have an existing offer",
    value: TYPES.EXISTING,
  },
  {
    label: "Need to create a new offer",
    value: TYPES.NEW,
  },
];
